import React, { Component } from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { Link, withRouter } from 'react-router-dom';
import { Typography, TextField } from '@material-ui/core';

import {
  getProductComments,
  postParentComment
} from '../../redux/actions/comments';
import { fetchPublicStats } from '../../redux/actions/user';
import RTVAvatar from '../../commons/RTVAvatar';
import AdornedButton from '../../commons/AdornedButton';
import {
  PARENT_COMMENT_POST_REQUESTED,
  PARENT_COMMENT_POST_SUCCESSFULL,
  PARENT_COMMENT_POST_ERRORED,
  PRODUCT_COMMENTS_REQUESTED,
  PRODUCT_COMMENTS_RETRIEVED,
  PRODUCT_COMMENTS_FAILED,
  USER_PUBLIC_STATS_RETRIEVED
} from '../../redux/actions/types';
import LoadingGif from '../../images/Loading.gif';
import * as DateService from '../../services/DateService';
import removeEmoji from '../../utils/removeEmoji';
import { withTranslation } from 'react-i18next';
import { expressToggle } from '../../redux/actions/app';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    minWidth: '80%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  childComment: {
    marginLeft: theme.spacing(6.25),
    padding: '0px !important'
  },
  commentAuthor: {
    fontWeight: 800
  },
  comment: {
    padding: theme.spacing(2, 2, 0, 0),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  commentHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingRight: theme.spacing(2),
    '& > *': {
      margin: theme.spacing(1)
    }
  },
  commentContent: {
    backgroundColor: '#efeded',
    color: theme.palette.secondary.main,
    borderRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: 0,
    padding: theme.spacing(0.5, 2, 0.5, 2),
    margin: theme.spacing(0, 0, 0.5, 0)
  },
  commentForm: {
    display: 'flex',
    alignItems: 'end',
    position: 'relative',
    width: '100%'
  },
  commentFormHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.spacing(1),
    zIndex: 1,
    position: 'absolute',
    top: `-${theme.spacing(1)}px`,
    left: `-${theme.spacing(1)}px`
  },
  commentFormField: {
    marginTop: '2rem',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'flex-start'
    }
  },
  commentFormButton: {
    position: 'absolute !important',
    right: theme.spacing(2),
    bottom: `-${theme.spacing(1)}px`,
    [theme.breakpoints.down('sm')]: {
      position: 'relative !important'
    }
  },
  commentFormInput: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      '& > div': {
        '& > textarea': {
          fontSize: '0.9rem'
        }
      }
    }
  },
  commentFormAvatar: {
    marginRight: theme.spacing(1)
  },
  commentDate: {
    color: '#707070',
    fontSize: '0.8rem'
  },
  loadMore: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(1)
  },
  loadMoreButton: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    cursor: 'pointer'
  },
  commentDateAndLink: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      marginRight: theme.spacing(0.5)
    }
  },
  answerButton: {
    fontSize: '0.8rem',
    color: theme.palette.primary.main
  }
});

class Comments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      comments: [],
      childComment: '',
      comment: '',
      publicStats: null,

      offset: 1,

      postingComment: false,
      fetchingComments: false,
      moreComments: true
    };
  }

  componentDidMount() {
    this.props.getProductComments(this.props.product, 0, 3);
    this.props.fetchPublicStats(this.props.productUser.id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userStatus !== this.props.userStatus) {
      if (this.props.userStatus === USER_PUBLIC_STATS_RETRIEVED) {
        this.setState({
          publicStats: this.props.publicStats[this.props.productUser.id]
        });
      }
    }

    if (prevProps.commentStatus !== this.props.commentStatus) {
      if (this.props.commentStatus === PARENT_COMMENT_POST_REQUESTED) {
        this.setState({ postingComment: true });
      }

      if (this.props.commentStatus === PARENT_COMMENT_POST_SUCCESSFULL) {
        this.setState(state => ({
          ...state,
          postingComment: false,
          comment: '',
          comments: this.props.comments
        }));
      }

      if (this.props.commentStatus === PARENT_COMMENT_POST_ERRORED) {
        this.setState({ postingComment: false });
      }

      if (this.props.commentStatus === PRODUCT_COMMENTS_REQUESTED) {
        this.setState({ fetchingComments: true });
      }

      if (this.props.commentStatus === PRODUCT_COMMENTS_RETRIEVED) {
        this.setState({
          fetchingComments: false,
          comments: this.props.comments,
          moreComments: this.props.hasMoreComments
        });
      }

      if (this.props.commentStatus === PRODUCT_COMMENTS_FAILED) {
        this.setState({ fetchingComments: false });
      }
    }

    if (prevProps.product !== this.props.product) {
      this.props.getProductComments(this.props.product);
    }

    if (prevProps.productUser.id !== this.props.productUser.id) {
      this.props.fetchPublicStats(this.props.productUser.id);
    }
  }

  commentProduct = () => {
    if (this.state.comment.trim() !== '') {
      this.props.postParentComment(this.props.product, this.state.comment);
    }
  };

  handleChange = ({ target: { value } }) => {
    this.setState({ comment: removeEmoji(value.substring(0, 255)) });
  };

  handleOnKeyUp = event => {
    if (event.key === 'Enter' && event.ctrlKey) {
      event.preventDefault();
      this.commentProduct();
    }
  };

  requestMoreComments = () => {
    if (this.state.fetchingComments) {
      return;
    }

    this.props.getProductComments(this.props.product, this.state.offset, 3);
    this.setState(state => ({
      ...state,
      offset: state.offset + 3
    }));
  };

  render() {
    const { classes, user } = this.props;
    const { comments } = this.state;
    let avatarSrc = null;
    if (user && user.image) {
      avatarSrc = user.image.default_small;
    } else if (user && user.media) {
      avatarSrc = user.media.default_small || user.media.user_small;
    }

    return (
      <div id="comments" className={classes.root}>
        <Typography className={classes.commentAuthor}>Comentarios</Typography>
        {this.state.publicStats && (
          <Typography style={{ color: '#707070', fontSize: '0.9rem' }}>
            Última conexión hace{' '}
            {DateService.getDayDiffString(this.state.publicStats.last_activity)}
          </Typography>
        )}
        {comments.length === 0 && (
          <Typography>No hay comentarios. Sé la primera!</Typography>
        )}
        {comments.map(parentComment => (
          <div key={parentComment.id} className={classes.parentComment}>
            <div className={classes.comment}>
              <div className={classes.commentHeader}>
                <RTVAvatar
                  src={
                    parentComment.author.media
                      ? parentComment.author.media.default_small ||
                        parentComment.author.media.user_small
                      : null
                  }
                  style={classes.avatar}
                />
                <div className={classes.commentInfo}>
                  <Typography className={classes.commentAuthor}>
                    {parentComment.author.username}
                  </Typography>
                  <div className={classes.commentContent}>
                    <Typography variant="body1">
                      {parentComment.censored &&
                        user &&
                        parentComment.author.id === user.id &&
                        'El comentario fue moderado por no cumplir con las políticas del sitio. De detectarse más de un caso tu cuenta será dada de baja.'}
                      {parentComment.censored &&
                        (!user || parentComment.author.id !== user.id) &&
                        'El comentario fue moderado por no cumplir con las políticas del sitio.'}
                      {!parentComment.censored && parentComment.comment}
                    </Typography>
                  </div>
                  <div className={classes.commentDateAndLink}>
                    <Typography className={classes.commentDate}>
                      <Moment
                        date={parentComment.date_created}
                        format="ll"
                        locale="es"
                      />
                    </Typography>
                    {(parentComment.childComments === undefined ||
                      (parentComment.child_comments &&
                        !parentComment.child_comments.length)) &&
                      user &&
                      user.id === this.props.productUser.id && (
                        <Typography
                          component={Link}
                          to={`/mis-ventas/mensajes/${parentComment.id}`}
                          className={classes.answerButton}
                        >
                          Responder
                        </Typography>
                      )}
                  </div>
                </div>
              </div>
            </div>
            {parentComment.child_comments &&
              parentComment.child_comments
                .reduce((childs, current, index) => {
                  if (
                    current.censored &&
                    user &&
                    current.author.id === user.id
                  ) {
                    current.comment =
                      'El comentario fue moderado por no cumplir con las políticas del sitio. De detectarse más de un caso tu cuenta sera dada de baja.';
                  } else if (current.censored) {
                    current.comment =
                      'El comentario fue moderado por no cumplir con las políticas del sitio.';
                  }
                  if (index === 0) {
                    return [
                      {
                        ...current,
                        comment: [current.comment]
                      }
                    ];
                  }

                  if (
                    childs[childs.length - 1].author.id === current.author.id
                  ) {
                    // eslint-disable-next-line
                    childs[childs.length - 1].date_created =
                      current.date_created;
                    childs[childs.length - 1].comment.push(current.comment);
                    return childs;
                  }

                  return [
                    ...childs,
                    {
                      ...current,
                      comment: [current.comment]
                    }
                  ];
                }, [])
                .map((childComment, index, arr) => (
                  <div
                    key={childComment.id}
                    className={`${classes.comment} ${classes.childComment}`}
                  >
                    <div className={classes.commentHeader}>
                      <RTVAvatar
                        src={
                          childComment.author.media
                            ? childComment.author.media.default_small ||
                              childComment.author.media.user_small
                            : null
                        }
                        style={classes.avatar}
                      />
                      <div className={classes.commentInfo}>
                        <Typography className={classes.commentAuthor}>
                          {childComment.author.username}
                        </Typography>
                        {childComment.comment.map((com, index) => (
                          <div key={index} className={classes.commentContent}>
                            {com}
                          </div>
                        ))}
                        <div className={classes.commentDateAndLink}>
                          <Typography className={classes.commentDate}>
                            <Moment
                              date={parentComment.date_created}
                              format="ll"
                              locale="es"
                            />
                          </Typography>
                          {user &&
                            user.id === this.props.productUser.id &&
                            index === arr.length - 1 &&
                            childComment.author.id !== user.id && (
                              <Typography
                                component={Link}
                                to={`/mis-ventas/mensajes/${parentComment.id}`}
                                className={classes.answerButton}
                              >
                                Responder
                              </Typography>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
          </div>
        ))}
        {this.state.moreComments && (
          <div className={classes.loadMore}>
            <Typography
              onClick={this.requestMoreComments}
              className={classes.loadMoreButton}
            >
              Ver más comentarios
              {this.state.fetchingComments ? (
                <img
                  src={LoadingGif}
                  alt="loading..."
                  style={{
                    marginLeft: '8px',
                    width: '24px',
                    height: '24px'
                  }}
                />
              ) : (
                <KeyboardArrowDownIcon
                  size="24px"
                  color="primary"
                  style={{ marginLeft: '8px' }}
                />
              )}
            </Typography>
          </div>
        )}
        {user ? (
          user.id !== this.props.productUser.id &&
          !this.props.disabled && (
            <div className={classes.commentForm}>
              <div className={classes.commentFormHeader}>
                <RTVAvatar
                  className={classes.commentFormAvatar}
                  src={avatarSrc}
                />
                <Typography className={classes.commentAuthor}>
                  {user.username}
                </Typography>
              </div>
              <div className={classes.commentFormField}>
                <TextField
                  color="secondary"
                  className={classes.commentFormInput}
                  variant="outlined"
                  value={this.state.comment}
                  onChange={this.handleChange}
                  multiline
                  type="text"
                  rows="4"
                  fullWidth
                  helperText={`No incluyas datos de contacto ni links o tu pregunta será bloqueada. ${this.state.comment.length}/255`}
                  placeholder={this.props.t('postYourComment', {
                    ns: 'products'
                  })}
                  onKeyUp={this.handleOnKeyUp}
                />
                <AdornedButton
                  variant="contained"
                  color="primary"
                  className={classes.commentFormButton}
                  disabled={this.state.postingComment}
                  loading={this.state.postingComment}
                  onClick={this.commentProduct}
                >
                  COMENTAR
                </AdornedButton>
              </div>
            </div>
          )
        ) : (
          <div className={classes.notLoggedInMessage}>
            <Typography color="primary">
              Ingresa para dejar un comentario haciendo{' '}
              <Link
                onClick={() =>
                  this.props.expressToggle(true, {
                    entity: 'Product',
                    identifier: this.props.product
                  })
                }
              >
                click aquí
              </Link>
            </Typography>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
  commentStatus: state.comments.status,
  comments: state.comments.comments,
  hasMoreComments: state.comments.hasMoreComments,
  userStatus: state.user.status,
  publicStats: state.user.publicStats
});

const mapDispatchToProps = dispatch => ({
  getProductComments: (product, offset, pageSize) =>
    dispatch(getProductComments(product, offset, pageSize)),
  postParentComment: (product, comment) =>
    dispatch(postParentComment(product, comment)),
  fetchPublicStats: user => dispatch(fetchPublicStats(user)),
  expressToggle: (toggle, fromAction) =>
    dispatch(expressToggle(toggle, fromAction))
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(withRouter(Comments)))
);
